/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { ExactStringUnionArray } from "helpers";
import { ReviewReason } from "store/api/generatedApi.tsx";

export const REVIEW_REASON_VALUES = [
  "too_few_examples",
  "missing_labels",
  "incompatible_labels",
  "incompatible_timing",
  "ambiguous_matching",
  "invalid_sequence",
  "comment",
  "false_positive",
  "false_negative",
  "low_confidence_event",
  "low_confidence_material",
  "low_confidence_area",
  "likely_error",
  "confusable_material",
  "unplanned_material",
  "railcar_disagreement",
  "mass_outlier",
  "duplicate_mass",
] as const;

type CheckReviewReasons = ExactStringUnionArray<
  typeof REVIEW_REASON_VALUES,
  ReviewReason
>;

const check: CheckReviewReasons = true;

if (!check) {
  throw new Error("ReviewReasons do not match.");
}
